var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('a',{staticClass:"link",attrs:{"data-cy":"qr-code","href":this.getJoinUrl(),"target":"_blank"}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":"qr-code"}})])
}]

export { render, staticRenderFns }